import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type BadgeVariant = "default" | "secondary" | "outline" | "archived";

const badgeVariantClasses: Record<BadgeVariant, string> = {
  default: "bg-primary/10 text-primary",
  secondary: "bg-secondary text-secondary-foreground",
  outline: "border border-border bg-white/65 text-foreground",
  archived: "bg-slate-900/10 text-slate-700",
};

export function badgeVariants({
  className,
  variant = "default",
}: {
  className?: string;
  variant?: BadgeVariant;
} = {}) {
  return cn(
    "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em]",
    badgeVariantClasses[variant],
    className,
  );
}

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
}

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return <div className={badgeVariants({ className, variant })} {...props} />;
}

export { Badge };
